import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import styles from './index.module.less'
import Iconfont from '@base/lib/Iconfont';
import { isInViewport } from 'ava-util/dist/dom-node';
import { addEvent, removeEvent } from 'ava-util/dist/dom-event';
import { Button } from 'antd';
import { useStoreState } from 'base/store';
import PureVideo, { IPureVideoRef } from '@base/lib/PureVideo';

interface IProps {
    className?: string;
    src: string;
    visible: boolean;
}

const VideoViewer: React.FC<IProps> = (props) => {
    const { className, src, visible } = props
    const { ua } = useStoreState('rootStore');
    const [active, setActive] = useState<boolean>(false);
    const wrapRef = useRef<HTMLDivElement>(null);
    const floatRef = useRef<HTMLDivElement>(null);
    const playingRef = useRef<boolean>(false);
    const videoRef = useRef<IPureVideoRef>(null);

    // 视频滚动位置
    const handleScroll = () => {
        const wrapEl = wrapRef?.current as HTMLDivElement;
        const floatEl = floatRef?.current as HTMLDivElement;
        const video2Els = (videoRef.current as IPureVideoRef).getElements();

        if (isInViewport(wrapEl)) {
            if (!wrapEl.querySelector('video')) {
                if (ua.isMobile) {
                    video2Els.video.controls = true;
                }
                wrapEl.appendChild(video2Els.wrap);
            }
            floatEl.style.display = 'none';
        } else if (playingRef.current) {
            if (!floatEl.querySelector('video')) {
                if (ua.isMobile) {
                    video2Els.video.controls = false;
                }
                floatEl.appendChild(video2Els.wrap);
            }
            floatEl.style.display = 'block';
        }
    }

    // 关闭视频浮层
    const handleClose = () => {
        const wrapEl = wrapRef?.current as HTMLDivElement;
        const floatEl = floatRef?.current as HTMLDivElement;
        const video2Els = (videoRef.current as IPureVideoRef).getElements();
        video2Els.video.pause();
        if (ua.isMobile) {
            video2Els.video.controls = true;
        }
        wrapEl.appendChild(video2Els.wrap);
        floatEl.style.display = 'none';
    };

    useEffect(() => {
        setActive(true);
    }, [])

    useEffect(() => {
        if (visible) {
            videoRef.current && videoRef.current.play();
            addEvent(window, 'scroll', handleScroll);
            return () => {
                removeEvent(window, 'scroll', handleScroll);
            };
        } else {
            videoRef.current && videoRef.current.pause();
        }
    }, [visible]);

    return (
        <>
            <div ref={wrapRef} className={cn(className, styles.wrap)}>
                <PureVideo
                    src={src}
                    ref={videoRef}
                    onPlay={() => playingRef.current = true}
                    onPause={() => playingRef.current = false}
                    controls
                    muted
                />
            </div>

            {visible && active && createPortal(
                (
                    <div
                        ref={floatRef}
                        className={styles.float}
                        style={{ display: 'none' }}
                    >
                        <Button
                            type="text"
                            icon={<Iconfont className="icon-close-bold"/>}
                            className={styles.close}
                            onClick={handleClose}
                        />
                    </div>
                ),
                document.body
            )}
        </>
    )
}

export default React.memo(VideoViewer);
